// pages/Home.jsx
import React from "react";
import Navigation from "../components/Common/header/Navigation";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import ModelGallery from "../components/ModelGallery";
import FeaturedProducts from "../components/FeaturedProducts";
import Footer from "../components/Common/footer/Footer";
import BundlePromise from "../components/BundlePromise";
import PureMadnessBanner from "../components/PureMadnessBanner";

const Home = () => {
    return (
        <div>
            <Navigation />
            <HeroSection />
            <AboutSection />
            <ModelGallery />
            <FeaturedProducts />
            <PureMadnessBanner />
            <BundlePromise />
            <Footer />
        </div>
    );
};

export default Home;